export enum AnalystTypeEnum {
  Supervisor = "Supervisor",
  Operator1 = "Operator1",
  Operator2 = "Operator2",
  Expert = "Expert"
}

export const allAnalystTypes = Object.keys(AnalystTypeEnum);
